import React from 'react'
import { StyleSheet } from 'react-native'

import { B4, Stack, colors } from '@zet/design-system'
import ZetLoyalty from '@zet/feature-brands/assets/svg/zetLoyalty.svg'
import { EXPERT, PRO } from '@zet/feature-loyalty/utils/Constants'
import { i18n } from '@zet/localization'
import LockOutLined from '@zet/svg/lockOutlined'
import { PaymentStatus } from '@zet/utils/Constants'

const BonusBanner = ({ data, payment }) => {
  const handleBonusBanner = () => {
    switch (data?.cohort) {
      case PRO:
        return i18n.t('loyaltyDetails.proPercentage')
      case EXPERT:
        return i18n.t('loyaltyDetails.expertPercentage')
      default:
        return i18n.t('loyaltyDetails.geniusPercentage')
    }
  }
  const handleBorderColor = () => {
    switch (payment?.status) {
      case PaymentStatus.PENDING:
        return styles.pendingBorderColor
      case PaymentStatus.PAID:
        return styles.coinsBorder
      case PaymentStatus.FAILED:
        return styles.failedErrorBorder
      case PaymentStatus.REJECTED:
        return styles.failedErrorBorder
      case PaymentStatus.LOCKED:
        return styles.lockedBorderColor
      default:
        return styles.pendingBorderColor
    }
  }
  return (
    <>
      {payment?.payoutType &&
        (payment?.payoutType === 'loyalty_payout' ||
          payment?.payoutType === 'loyalty_differen') && (
          <B4
            className="mx-2 -mb-2 mt-2 self-start rounded border bg-white p-2"
            style={handleBorderColor()}
          >
            <Stack>
              {payment?.status === PaymentStatus.LOCKED ? (
                <LockOutLined className="top-1 mr-1" height={19} width={19} />
              ) : (
                <ZetLoyalty className="top-1 mr-2" />
              )}
            </Stack>
            {handleBonusBanner()}
          </B4>
        )}
    </>
  )
}

export default BonusBanner
const styles = StyleSheet.create({
  coinsBorder: {
    borderColor: colors.success[30],
  },
  failedErrorBorder: {
    borderColor: colors.error[20],
  },
  pendingBorderColor: {
    borderColor: colors.primary[30],
  },
  lockedBorderColor: {
    borderColor: colors.grays[40],
  },
})
